import React, { FC } from 'react';

import { Box, Center, Stack, UseDisclosureProps } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { customTheme } from 'theme';

import { MonitoringIcon } from 'components/Icons';
import { actions } from 'containers/Jit/MaskingPolicies/slice';

interface Props {
  account: Record<string, any>;
  /** The selected role record. Each caller keeps it in a different place, so
   * the caller must give it. It holds `uuid`, `name` and `permissions`. */
  role: Record<string, any>;
  disclosure: UseDisclosureProps;
  onClick: () => void;
}

export const OktaIdentitiesUsingRole: FC<Props> = props => {
  const { account, role, disclosure, onClick } = props;
  const dispatch = useDispatch();
  // A row with no role is an empty object. An empty object is true in a
  // condition, so the code must look at the uuid of the role record.
  const roleUuid = role?.uuid;
  return (
    <Stack position="relative">
      <Box
        boxSize={5}
        color={!!roleUuid ? 'primary' : customTheme.colors.gray['250']}
        cursor={!!roleUuid ? 'pointer' : 'not-allowed'}
        onClick={() => {
          if (!roleUuid) return;
          onClick();
          disclosure?.onOpen?.();
          dispatch(
            actions.getIdentitiesUsingDataRole({
              q: {
                identityAccountId: account?.data?.identity_provider_id,
                dataAccount: account?.value,
                dataProvider: account?.data?.provider,
                roleUuid,
              },
            }),
          );
        }}
      >
        <Center>
          <MonitoringIcon />
        </Center>
      </Box>
    </Stack>
  );
};
